const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { assetClass: 'object.asset-class.options.kapitalgeber' }, { typeOfFinancing: 'object.type-of-financing.options.mezzanine-loan' }]
}

export default conditions
